// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"eae45b27","453":"c1bb1965","513":"f2f63370"}[chunkId] + ".chunk.js";
};